
<div class="val-controle-conteneur val-flex-conteneur">
  <val-simple-libelle [libelle]="label" [style.width.px]="tailleLabel"></val-simple-libelle>
  <div class="val-flex-1 val-flex-conteneur val-flex-colonne">
    <div class="val-flex-1"></div>
    <ng-content></ng-content>
    <div class="val-flex-1"></div>
  </div>
</div>
